import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Signal } from 'src/app/shared/model/signal';
import { ErrorService } from 'src/app/shared/services/error.service';
import { WorldWatchService } from 'src/app/shared/services/worldwatch.service';

@Component({
  selector: 'app-viewsignal',
  templateUrl: './viewsignal.component.html',
  styleUrls: ['./viewsignal.component.scss']
})
export class ViewSignalComponent implements OnInit {

  signalRef: string;
  signal: Signal;
  loadingSignal: boolean;

  constructor(private route: ActivatedRoute, private worldwatchService: WorldWatchService, private errorService: ErrorService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.signalRef = params['signalRef']);

    this.loadingSignal = true;
    this.worldwatchService.signal(this.signalRef)
      .then(res => {
        this.signal = res;
        this.loadingSignal = false;
      })
      .catch(err => {
        this.loadingSignal = false;
        this.errorService.handlerError(err);
      });

  }
  
  likeSignal(): void {
    this.worldwatchService.signalLike(this.signalRef)
      .then(res => {
        this.signal.likeCount++;
      })
      .catch(err => {
        this.errorService.handlerError(err)
      });
  }

  downloadPDF(): void { 
    this.worldwatchService.signalPDF(this.signalRef)
      .subscribe(val => {
        var file = new Blob([val], {type: 'application/pdf'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        }else {
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
    }), 
    error => console.log('Error downloading the file'),
    () => console.info('File downloaded successfully');
  }
}
